import React, { useState, useEffect } from "react";
import Header from "../components/header";
import About from "../components/about";
import Hero from "../components/hero";
import Projects from "../components/projects";
import Footer from "../components/footer";
import Intro from "../components/intro";
import { Helmet } from "react-helmet";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loading ? document.querySelector("body").classList.add("loading") : document.querySelector("body").classList.remove("loading");
  }, [loading]);
  return (
    <>
      <Helmet>
        <title>Portfolio</title>
      </Helmet>
      {loading ? (
        <>
          <Intro setLoading={setLoading} />
        </>
      ) : (
        <div className="bg-bg1">
          <Header loading={loading} />
          <Hero loading={loading} />
          <div className="bg-bg1 my-20" />
          <Projects />
          <div className="bg-bg1 sm:my-40 my-16" />
          <About />
          <div className="bg-bg1 sm:my-40 my-16" />
          <Footer />
        </div>
      )}
    </>
  );
}
